import React, { useContext } from 'react'
import { Box } from '@achieve/ascend'
import { AchieveLink } from 'components/AchieveLink'
import styles from './SocialMediaProfile.module.scss'
import { FacebookShared } from 'components/Svgs/FacebookShared.js'
import { LinkedinShared } from 'components/Svgs/LinkedinShared.js'
import { XShared } from 'components/Svgs/XShared.js'
import { mainProductConfig } from 'services/contentful/helpers'
import { LayoutContext } from 'providers/LayoutProvider'

function SocialMediaProfile({ facebook, twitter, linkedin, sizeIcons = 25 }) {
  const { state: { siteEnv } = {} } = useContext(LayoutContext)
  return (
    <Box className={styles['social-sharing']}>
      {facebook && (
        <AchieveLink
          className={styles['social-sharing-icon']}
          href={facebook}
          target="_blank"
          track={{
            list_name: 'Post Social Profile',
            click_id: 'Facebook',
            click_position: 0,
            click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']} | Facebook`,
            click_type: 'Phone Click',
            nav_link_section: 'Author Social Links',
          }}
        >
          <FacebookShared title="Facebook" height={sizeIcons} width={sizeIcons} />
        </AchieveLink>
      )}
      {twitter && (
        <AchieveLink
          className={styles['social-sharing-icon']}
          href={twitter}
          target="_blank"
          track={{
            list_name: 'Post Social Profile',
            click_id: 'Twitter',
            click_position: 1,
            click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']} | Twitter`,
          }}
        >
          <XShared title="Twitter" height={sizeIcons} width={sizeIcons} />
        </AchieveLink>
      )}
      {linkedin && (
        <AchieveLink
          className={styles['social-sharing-icon']}
          href={linkedin}
          target="_blank"
          track={{
            list_name: 'Post Social Profile',
            click_id: 'Linkedin',
            click_position: 2,
            click_text: `${mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']} | Linkedin`,
          }}
        >
          <LinkedinShared title="Linkedin" height={sizeIcons} width={sizeIcons} />
        </AchieveLink>
      )}
    </Box>
  )
}

export { SocialMediaProfile }
